export default {
    getCookie(name) {
        const value = `; ${document.cookie}`,
            parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts
                .pop()
                .split(';')
                .shift();
        }
    },

    requestRefUuid() {
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    },
};
